const fechagloblal =  new Date();
let mes = (fechagloblal.getMonth() + 1).toString().padStart(2, '0')
const FechaActual = fechagloblal.getFullYear()+'-'+mes+'-'+fechagloblal.getDate();

export default FechaActual;